function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#231F20",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.3 10.7V7c0-.9-.7-1.7-1.7-1.7-.9 0-1.6.8-1.6 1.7v5.3c0 .9.7 1.7 1.7 1.7H17c.9 0 1.7-.7 1.7-1.7 0-.9-.7-1.7-1.7-1.7h-3.7v.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 3.6c4.6 0 8.4 3.8 8.4 8.4 0 4.6-3.8 8.4-8.4 8.4-4.6 0-8.4-3.8-8.4-8.4 0-4.6 3.8-8.4 8.4-8.4zM12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.7 0 12 0z",
  fillRule: "nonzero"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;